import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/41_card_back_white_dome/41_card_back_white_dome"
 * Contains 1 texture(s)
 */
export class CardsBacks41CardBackWhiteDomeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/41_card_back_white_dome/41_card_back_white_dome';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '41_white_dome.png'
    ] as const;
}
